import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QueueMonitorsRepositoryService } from '../../../services/queue-monitors/queue-monitors-repository.service';
import { AutomationMonitorComponent } from '../base-monitor-component';
import { AutomationMonitor, ConfirmDialogComponent } from 'reg-hub-common';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-queue-monitors',
    templateUrl: './queue-monitors.component.html',
    styleUrls: ['./queue-monitors.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QueueMonitorsComponent extends AutomationMonitorComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  
  protected displayedColumns = [
    'icon',
    'automationName',
    'isAutomationEnabled',
    'currentQueueSize',
    'maxQueueSize',
    'lastSuccessfulRunDate',
    'delete'
  ]

  constructor(
    private queueMonitorService: QueueMonitorsRepositoryService,
    private dialog: MatDialog) { 
    super(queueMonitorService);
  }

  ngOnInit(): void {
    // This table loads its own data so the dashboard's page-wide spinner
    // doesn't wait on a request only this table needs.
    this.repo.getFirstPageSubscribable().subscribe({
      error: () => {
        //Handle Error
      }
    });
  }

  onDeleteMonitor(automationMonitor: AutomationMonitor) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { 
        title: this.transloco.translate('queueMonitors.confirmDeleteThisAutomationMonitor'), 
        confirmationPrompt: "",
        positiveResponseLabel: this.transloco.translate('common.buttons.delete'),
        negativeResponseLabel: this.transloco.translate('common.buttons.cancel')
      },
      minWidth: '800px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // submission is confirmed, submit order
        this.deleteAutomationMonitor(automationMonitor);
      }
    });
  }

  onUpdateAutomationMonitor(automationMonitor: AutomationMonitor) {
    if (automationMonitor.isAutomationEnabled) {
      //No need for warning when turning back on
      this.updateAutomationMonitor(automationMonitor);
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: { 
          title: this.transloco.translate('queueMonitors.disableAutomation'), 
          confirmationPrompt: this.transloco.translate('queueMonitors.confirmDiableThisAutomationMonitor'),
          positiveResponseLabel: this.transloco.translate('queueMonitors.confrm'),
          negativeResponseLabel: this.transloco.translate('common.buttons.cancel')
        },
        minWidth: '800px'
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.updateAutomationMonitor(automationMonitor);
        } else {
          automationMonitor.isAutomationEnabled = true;
        }
      });
    }
  }

  updateAutomationMonitor(automationMonitor: AutomationMonitor) {
    this.queueMonitorService.updateMonitor(automationMonitor)
    .subscribe({
      next: () => {
        this.repo.refresh();
      },
      error: () => {
        //Handle Error
      }
    });
  }

  deleteAutomationMonitor(automationMonitor: AutomationMonitor) {
    this.queueMonitorService.deleteMonitor(automationMonitor.id)
    .subscribe({
      next: () => {
        this.repo.refresh();
      },
      error: () => {
        //Handle Error
      }
    });
  }
}
